// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"fccd610d","308":"d0d6d796"}[chunkId] + ".chunk.css";
};